import React, { useContext } from 'react';
import { useNavigate, Outlet, useLocation } from 'react-router-dom';
import { VisualizationContext } from '../../context/VisualizationContext';

const Layout = () => {
  const navigate = useNavigate();
  const visualization = useContext(VisualizationContext);
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  const isArtistPage = location.pathname.startsWith('/artist/');
  const hideGlobalHeader = isArtistPage || location.pathname.startsWith('/profile');

  const handleLogoClick = (e) => {
    e.preventDefault();
    if (visualization && visualization.resetGraphData) {
      visualization.resetGraphData();
    }
    navigate('/', { replace: true });
  };

  return (
    <div className="layout">
      {!hideGlobalHeader && (
        <header className={`header ${isHomePage ? 'home-header' : ''}`}>
          <div className="header-content">
            <a href="/" onClick={handleLogoClick} className="header-wordmark">
              Band Bacon
            </a>
          </div>
        </header>
      )}
      <main className="main-content">
        <Outlet />
      </main>
    </div>
  );
};

export default Layout;
